import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ObjectSearchState, } from '../../../../store/objectSearch/ObjectSearchState';
import { selectObjectSearchState } from '../../../../store/selectors';
import { usePreviousValue } from '@sas/nova-commons/hooks/usePreviousValue';
import { DemographicsResultsDialog } from './DemographicsResultsDialog';
import { DemographicsSelectorDialog } from './DemographicsSelectorDialog';
export const DemographicsBase = (props) => {
    const { dialogOpenState, setDialogOpenState } = props;
    const previousSelectorDialogIsOpen = usePreviousValue(dialogOpenState.selectorDialogIsOpen);
    useEffect(() => {
        var _a;
        const feature = (_a = props.features) === null || _a === void 0 ? void 0 : _a[dialogOpenState.featureIndex];
        if ((feature === null || feature === void 0 ? void 0 : feature.type) === 'area' && feature.country) {
            if (previousSelectorDialogIsOpen !== dialogOpenState.selectorDialogIsOpen &&
                dialogOpenState.selectorDialogIsOpen) {
                props.actions.setSelectedDemographicCountry(props.id, {
                    index: dialogOpenState.featureIndex,
                    country: feature.country,
                });
            }
        }
    }, [
        props.id,
        props.features,
        dialogOpenState.featureIndex,
        dialogOpenState.selectorDialogIsOpen,
        props.actions,
        previousSelectorDialogIsOpen,
    ]);
    return (React.createElement(Fragment, null, props.canDoPremiumServices ? (React.createElement(Fragment, null,
        dialogOpenState.selectorDialogIsOpen ? (React.createElement(DemographicsSelectorDialog, { isOpen: dialogOpenState.selectorDialogIsOpen, closeDialog: (action) => {
                setDialogOpenState((prevState) => (Object.assign(Object.assign({}, prevState), { selectorDialogIsOpen: false })));
                if (action === 'ok') {
                    setDialogOpenState((prevState) => (Object.assign(Object.assign({}, prevState), { resultsDialogIsOpen: true })));
                }
            }, id: props.id, featureIndex: dialogOpenState.featureIndex })) : null,
        dialogOpenState.resultsDialogIsOpen ? (React.createElement(DemographicsResultsDialog, { isOpen: dialogOpenState.resultsDialogIsOpen, onCloseDialog: (action) => {
                setDialogOpenState((prevState) => (Object.assign(Object.assign({}, prevState), { resultsDialogIsOpen: action === 'edit' })));
                if (action === 'edit') {
                    setDialogOpenState((prevState) => (Object.assign(Object.assign({}, prevState), { selectorDialogIsOpen: true })));
                }
            }, id: props.id, featureIndex: dialogOpenState.featureIndex })) : null)) : null));
};
export const Demographics = connect((state, props) => {
    var _a;
    const { features, canDoPremiumServices } = (_a = selectObjectSearchState(state, props.id)) !== null && _a !== void 0 ? _a : {};
    return {
        features,
        canDoPremiumServices,
    };
}, (dispatch) => ({
    actions: bindActionCreators(ObjectSearchState.actions, dispatch),
}))(DemographicsBase);
